import React from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import CRMPromptPage from 'src/components/layouts/CRMPromptPage'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import DealList from '../DealList'
import { BoardViewShim } from '../DealList/BoardViewShim'

export default function DealView() {
  const { crm: crmFlag } = useFlags()
  return (
    <BasePage width={'xl'}>
      <DocumentTitle title={'View Deals'} />
      {crmFlag ? (
        <div>
          <DealList />
        </div>
      ) : (
        <CRMPromptPage Background={<BoardViewShim />} />
      )}
    </BasePage>
  )
}
